module.exports = __webpack_public_path__ + "img/phonehappy.f85df5a6.webp";